import { useEffect } from 'react'
import { useAppDispatch } from '../../../store/hooks'
import {
  mergeAllBoundingBoxes,
  setInitialBoundingBoxes,
  setAcceptedBoundingBoxes,
  setRejectedBoundingBoxes,
  clearUndoStack,
  clearRedoStack,
  setSelectedBoundingBox,
} from '../../../store/slices/annotationSlice'
import { AnnotationDataBoundingBox } from '../../../types/models/annotation'

export type ReviewMode = 'prediction' | 'annotation'

interface UseInitializeBoxesParams {
  mode: ReviewMode
  boxes: AnnotationDataBoundingBox[]
}

/**
 * Seeds Redux with a prepared list of UI boxes and resets review-specific state.
 */
export function useInitializeBoxes({ mode, boxes }: UseInitializeBoxesParams): void {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!boxes) return
    dispatch(clearUndoStack())
    dispatch(clearRedoStack())
    dispatch(setSelectedBoundingBox(undefined))

    dispatch(mergeAllBoundingBoxes(boxes))
    dispatch(setInitialBoundingBoxes(boxes))
    dispatch(setRejectedBoundingBoxes([]))
    dispatch(setAcceptedBoundingBoxes([]))
  }, [dispatch, mode, boxes])
}
